const terms = `
<div class="warning">
(!) 배송 당시, 기상 악화가 있을 경우, 운임이 조정될 수 있습니다.<br />
(!) 배송 과정에서 다양한 사유로 회차 발생시, 확정운임이 변경될 수 있습니다.<br />
(!) 확정 운임의 변경과 관련된 문의는 카카오T 고객센터(1599-9400) 로 문의해 주시길 바랍니다.<br />
</div>
`;
export default terms;
